export interface Column1ViewModelState {
  genericDocInvListingState: any;
  }
  
  export const initialState: Column1ViewModelState = {
  genericDocInvListingState: null,
  };